import React from 'react';
import { FlexView } from '@cuemath/comps';
import { Button, Dropdown, Separator, Text } from '@cuemath/web-comps';
import LAYOUT from 'constants/layout';
import useLogic from './ResultNotAGoodMatch.logic';
import PropTypes from 'prop-types';
import ResultSuccess from '../result-success';

const { GUTTER } = LAYOUT;

const ResultNotAGoodMatch = ({ result }) => {
  const { mappingId, otherTeachers } = result ?? {};
  const {
    showOtherTeachersFound,
    reason,
    setReason,
    handleSubmit,
    isBusy,
    options,
    submitSuccess,
  } = useLogic({
    mappingId,
    otherTeachers,
  });

  const renderNotAGoodMatch = (
    <>
      {options?.length >= 0 && Array.isArray(options) ? (
        <>
          <Text variant="body1Regular">
            Not a good match? Please provide more details.
          </Text>
          <Separator height={GUTTER / 2} />
          <Dropdown
            label="Select a reason"
            options={options}
            onChange={selected => setReason(selected)}
            value={reason}
            width="100%"
            optionsWidth="90%"
            type="primary"
            height="fit-content"
            placeholder="Reason"
          />
          <Separator height={GUTTER * 3} />
          <FlexView alignItems="center">
            <Button
              isDisabled={!reason}
              isBusy={isBusy}
              label={showOtherTeachersFound ? 'Show other teachers' : 'Submit'}
              size="small"
              onClick={handleSubmit}
            />
          </FlexView>
        </>
      ) : (
        'Loading...'
      )}
    </>
  );
  return (
    <FlexView>
      {submitSuccess && showOtherTeachersFound ? (
        <ResultSuccess result={result} showOtherTeachers />
      ) : (
        renderNotAGoodMatch
      )}
    </FlexView>
  );
};

ResultNotAGoodMatch.propTypes = {
  mappingId: PropTypes.string,
};

export default ResultNotAGoodMatch;
